export const appWorkspaceKey = 'app';
